<template>
  <div>
    <v-layout row wrap v-if="births.length">
      <v-flex xs6 mt-2 v-for="birth in births" :key="birth.id">
        <v-card class="text-xs-center mx-1" max-width="auto">
          <v-avatar size="90px" class="mt-2">
            <v-img
              :style="`border: 3.2px solid `+ birth.color + ';' + `background-color: ${birth.color}`"
              :src="birth.photo"
              aspect-ratio="1.9"
              class="hover"
            ></v-img>
          </v-avatar>
          <v-layout row wrap>    
            <v-flex xs12 style="height: 40px;"
              class="text-xs-center font-weight-bold text-uppercase text-12-security pt-1"
            >{{ birth.child_full_name }}</v-flex>
            <v-flex
              xs12
              class="center pb-1 text-13-security"
              style="line-height: 15px; height: 35px;"
            >{{ birth.father }}</v-flex>
            <v-flex
              xs12
              class="center pb-1 text-13-security"
              style="line-height: 10px;"
            >Nacido el {{ birth.birthday }}</v-flex>
            <v-flex xs12 mb-0>
              <v-btn
                flat
                small
                v-bind:href="`mailto:${birth.email}`"
                :color="birth.color"
                dark
                class="font-weight-bold"
                style="text-transform: none"
              >
                <span>
                  <img v-if="birth.color == '#8D0C9A'" class="material-icons p-auto color-purple" style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/baby-carriage.svg" alt="">
                  <img v-if="birth.color == '#008DCF'" class="material-icons p-auto color-lightblue " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/baby-carriage.svg" alt="">
                  <img v-if="birth.color == '#FF052B'" class="material-icons p-auto color-red " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/baby-carriage.svg" alt="">
                  <img v-if="birth.color == '#FF6E00'" class="material-icons p-auto color-orange " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/baby-carriage.svg" alt="">
                  <img v-if="birth.color == '#628D36'" class="material-icons p-auto color-green " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/baby-carriage.svg" alt="">
                  <img v-if="birth.color == '#bbb'" class="material-icons p-auto color-default " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/baby-carriage.svg" alt="">
                </span>
                <span class="pt-1 pl-1 caption font-weight-bold">Felicitar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else row wrap>
      <v-flex sm12 :style="paddingTop">
        <v-card flat>
          <v-card-text>
            <v-layout align-center justify-center row wrap fill-height>
              <v-flex
                class="text-29-security text-xs-center font-weight-bold"
                style="color: #525252"
              >No hay nacimientos este mes</v-flex>
              <v-flex text-xs-center>
                <router-link
                  to="celebremos-nacimientos/create"
                  class="text-14-security font-weight-bold"
                  style="color: #638d37"
                >¿Quieres agregar un nacimiento?</router-link>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>


<style scoped>
.user_birth .v-image__image {
  background-position: center top !important;
}
.greeting {
  font-family: Lato, sans-serif;
  line-height: 10px;
  font-size: 12px;
}
.link-format a {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  font-family: Lato, sans-serif;
  padding-left: 12px;
}
.link-format:hover {
  text-decoration: underline;
}
.color-purple{
  filter: invert(9%) sepia(94%) saturate(7242%) hue-rotate(294deg) brightness(79%) contrast(112%);
}
.color-lightblue {
  filter: invert(44%) sepia(64%) saturate(6283%) hue-rotate(178deg) brightness(100%) contrast(101%);
}
.color-red {
  filter: invert(13%) sepia(90%) saturate(7315%) hue-rotate(345deg) brightness(104%) contrast(116%);
}
.color-orange {
  filter: invert(41%) sepia(64%) saturate(1560%) hue-rotate(1deg) brightness(104%) contrast(104%);
}
.color-green {
  filter: invert(44%) sepia(59%) saturate(409%) hue-rotate(47deg) brightness(99%) contrast(92%);
}
.color-gris {
  filter: invert(82%) sepia(14%) saturate(0%) hue-rotate(144deg) brightness(89%) contrast(93%);
}
.color-default {
  filter: invert(81%) sepia(10%) saturate(25%) hue-rotate(345deg) brightness(94%) contrast(84%);
}
</style>

<script>
import { mapMutations, mapActions } from "vuex";
import config from "@/config";
import axios from "axios";
export default {
  data() {
    return {
      births: []
    };
  },
  methods: {
    ...mapMutations("births", ["setBirth"]),
    goToShowBirth(birth) {
      this.setBirth(birth);
      this.$router.push({
        name: "birth-show",
        params: { id: birth.id }
      });
    }
  },
  computed: {
    paddingTop() {
      return this.$vuetify.breakpoint.smAndDown ? 'padding-top: 15%' : 'padding-top: 35%'
    }
  },
  async mounted() {
    const { data: homeBirths } = await axios.get(
      process.env.VUE_APP_API_URL + "/births/get_home_births"
    );
    this.births = homeBirths

    if (this.$vuetify.breakpoint.smAndDown) {
      this.births = this.births.slice(0, 2)
    }
  }
};
</script>